import { useEffect, useState } from 'react';
import { Box, Typography, alpha, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useCosmos } from '../../../../providers/contexts/CosmosContext';
import { TWidgetTableColumn } from './constants';
import { useDashboardContext } from 'screens/dashboard/Dashboard';

type TrendingTitleCellProps = {
  row: any;
  columnConfig: TWidgetTableColumn;
  iconColumnKeyRef: string | null;
  legendConfig: any;
  iconsConfig: any;
};

// Renders a title as a link for the DataTableGrid.
const TitleLinkCell = ({
  row,
  columnConfig,
  iconColumnKeyRef,
  legendConfig,
  iconsConfig,
}: TrendingTitleCellProps) => {
  const theme = useTheme();
  const { activeSite } = useCosmos();
  const { hasProDataInsights } = useDashboardContext();
  const [link, setLink] = useState<string>(`#`);
  const [bgColor, setBgColor] = useState<string>('none');

  // Generate the link (Mostly for Trending Content).
  useEffect(() => {
    if (!row?.value || !hasProDataInsights) return;

    // Open article to its edit page.
    if (columnConfig?.link?.type === 'edit_asset') {
      setLink(`/${activeSite}/editorial/edit/${row?.row?.[columnConfig?.link?.id]}`);
    }

    // Open article to its stats page.
    if (columnConfig?.link?.type === 'stats') {
      setLink(
        `/${activeSite}/editorial/edit/${row?.row?.[columnConfig?.link?.id]}#stats`,
      );
    }
  }, [row, columnConfig, activeSite, hasProDataInsights]);

  // Generate the background color.
  useEffect(() => {
    if (!iconColumnKeyRef) return;

    // Find the icon variant to reference the background color.
    const iconRefRowValue = row?.row?.[iconColumnKeyRef];
    const iconRefVariant = iconsConfig?.list?.[iconRefRowValue]?.variant;

    // If the icon variant is not neutral, set the background color.
    if (!!iconRefVariant && iconRefVariant !== 'neutral') {
      // @ts-expect-error
      const linkBgColor = theme?.blox?.table?.[iconRefVariant];
      setBgColor(alpha(linkBgColor, 0.32));
    }
  }, [iconColumnKeyRef, legendConfig, iconsConfig, row, theme?.blox?.table]);

  return (
    <Box>
      <Typography
        variant="body2"
        component="span"
        sx={{
          p: 0.5,
          borderRadius: 1,
          backgroundColor: bgColor,
        }}
      >
        {hasProDataInsights ? (
          <RouterLink
            to={link}
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            {row.row.title}
          </RouterLink>
        ) : (
          <>{row.row.title}</>
        )}
      </Typography>
    </Box>
  );
};

export default TitleLinkCell;
